<template>
    <views class="person">
        <nav-bar
            :title="moduleTitle"
            :left-arrow="false"
            fixed>
        </nav-bar>
        <user-info
            :user-obj='userObj'>
        </user-info>
        <views class="person-menus">
            <van-grid :column-num="3">
                <van-grid-item @click="handleClick(item)" v-for="item in itemList" :key="item.title" :icon="item.icon" :text="item.title" />
            </van-grid>
            <!-- <person-item
                v-for="item in itemList"
                :key="item.title"
                :title="item.title"
                :icon="item.icon"
                @click="handleClick(item)">
            </person-item> -->
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import UserInfo from '@/components/userInfo'
import PersonItem from './PersonItem'
import tools from '@/mixins/tools'
import api from '@/utils/api'
import storage from '@/utils/storage'
export default {
    name: 'Person',
    mixins: [tools],
    components: {
        NavBar,
        UserInfo,
        PersonItem
    },
    data() {
        return {
            userObj: {},
            list: [
                {
                    title: '中奖消息',
                    icon: require('@/assets/images/person01.png'),
                    url: '/gift-list',
                    tip: false
                },
                {
                    title: '我的积分',
                    icon: require('@/assets/images/person02.png'),
                    url: '/point',
                    tip: false
                },
                {
                    title: '完善资料',
                    icon: require('@/assets/images/person03.png'),
                    url: '/improve-info',
                    tip: false
                },
                {
                    title: '我的收藏',
                    icon: require('@/assets/images/person04.png'),
                    url: '/collected?src=person',
                    tip: false
                },
                {
                    title: '追踪溯源',
                    icon: require('@/assets/images/person05.png'),
                    url: '/verify?type=trace&public=1',
                    tip: false
                },
                {
                    title: '附近门店',
                    icon: require('@/assets/images/person06.png'),
                    url: '/shop',
                    tip: false
                },
                {
                    title: '附近农户',
                    icon: require('@/assets/images/fujin@2x.png'),
                    url: '/farmer',
                    tip: false
                },
                {
                    title: '常见问题',
                    icon: require('@/assets/images/person07.png'),
                    url: '/faq',
                    tip: false
                },
                {
                    title: '意见反馈',
                    icon: require('@/assets/images/person08.png'),
                    // url: '/feedback',
                    url: '/feedbacklist',
                    tip: false
                },
                {
                    title: '联系我们',
                    icon: require('@/assets/images/person09.png'),
                    url: '/contact',
                    tip: false
                }
            ]
        }
    },
    computed: {
        moduleTitle() {
            return '个人中心'
        },
        isAdmin() {
            return true
            // return storage.get('userType') === '2'
        },
        itemList() {
            if (!this.isAdmin) {
                return this.list.filter(item => !(item.title === '追踪溯源' || item.title === '附近门店'))
            } else {
                return this.list
            }
        }
    },
    created() {
        this.getUserInfo()
    },
    mounted() {
        this.setBgColor()
    },
    destroyed() {
        this.resetBgColor()
    },
    activated() {
        this.setBgColor()
        this.getUserInfo()
    },
    deactivated() {
        this.resetBgColor()
    },
    methods: {
        handleClick(item) {
            if (item.title === '追踪溯源' || item.title === '附近门店') {
                this.windowPush(item.url)
            } else {
                this.push(item.url)
            }
        },
        getUserInfo() {
            api.getUserInfo().then((res) => {
                if (res) {
                    this.userObj = res.data
                    storage.set('member', JSON.stringify(res.data))
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
